import { getStore, defaultSearchStore } from 'owa-mail-search-store';
import { mutator, action } from 'satcheljs';
/**
 * Removes the suggestion from the suggestionSegments list
 * @param index index of the segment to remove
 */
export var removeSegment = action('removeSearchSegment', function (index) { return ({ index: index }); });
mutator(removeSegment, function (_a) {
    var index = _a.index;
    var state = getStore();
    state.suggestionSegments.splice(index, 1);
    state.selectedSuggestionIndex = defaultSearchStore.selectedSuggestionIndex;
});
/**
 * Moves the selectedPillIndex to the next or previous pill
 */
export var moveSelectedPillIndex = action('moveSelectedPillIndex', function (direction) { return ({
    direction: direction,
}); });
mutator(moveSelectedPillIndex, function (_a) {
    var direction = _a.direction;
    var state = getStore();
    state.selectedPillIndex += direction == 'next' ? 1 : -1;
});
/**
 * Sets the selectedPillIndex to the specified index
 */
export var setSelectedPillIndex = action('setSelectedPillIndex', function (index) { return ({ index: index }); });
mutator(setSelectedPillIndex, function (_a) {
    var index = _a.index;
    var state = getStore();
    state.selectedPillIndex = index;
});
//# sourceMappingURL=suggestionSegmentActions.js.map